import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import {
  ReflectionModalActions,
  TaskActions,
} from '@lyceo/shared/plan/data-access';
import { catchError, filter, map, of, switchMap } from 'rxjs';
import { isDefined } from '@lyceo/shared/util';
import { TaskCountActions } from './task-count.actions';
import { ApplicationFacade } from '@lyceo/shared/data-access';
import { TaskCountService } from '../../task-count.service';
import { PupilContextFacade } from '@lyceo/shared/pupil-context/data-access';

@Injectable()
export class TaskCountEffects {
  private readonly actions$: Actions = inject(Actions);
  private readonly pupilContextFacade: PupilContextFacade =
    inject(PupilContextFacade);
  private readonly applicationFacade: ApplicationFacade =
    inject(ApplicationFacade);
  private readonly taskCountService: TaskCountService =
    inject(TaskCountService);

  public getTaskCounts$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(
        TaskCountActions.getTaskCounts,
        TaskActions.updatePupilDoneSuccess,
        TaskActions.createSuccess,
        TaskActions.updateSuccess,
        ReflectionModalActions.updateReflectionSuccess,
      ),
      map(() => this.pupilContextFacade.homiPersonId()),
      filter(isDefined),
      switchMap((homiPersonId) =>
        this.taskCountService.getTaskCounts(homiPersonId).pipe(
          map((taskCounts) =>
            TaskCountActions.getTaskCountsSuccess({ taskCounts }),
          ),
          catchError((error: Error) =>
            of(TaskCountActions.getTaskCountsFailure({ error })),
          ),
        ),
      ),
    );
  });

  public getTaskCountsFailure$ = createEffect(
    () => {
      return this.actions$.pipe(
        ofType(TaskCountActions.getTaskCountsFailure),
        map(() => {
          this.applicationFacade.showToaster({
            type: 'error',
            message: 'Het ophalen van de openstaande taken is niet gelukt.',
          });
        }),
      );
    },
    { dispatch: false },
  );
}
